/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
import CircleTool from './CircleTool';
import Ellipse from '@/marker/Ellipse';

/**
 * 椭圆绘制工具
 */
export default class EllipseTool extends CircleTool {
  /**
   * 
   * @param e 
   */
  onMouseDown(e) {
    let { options } = this;
    let { map, layer } = this;
    let { latlng } = e;
    this.clear();//重复绘制，先移除旧图元
    //
    this.marker = new Ellipse(latlng, 0, options.feature).addTo(layer);
    map.on('mousemove', this.onMouseMove);
    map.once('mouseup', this.onEnd.bind(this));
  }

  /**
   * 
   * @param e 
   */
  onMouseMove(e) {
    let { marker } = this;
    let latlng = e.latlng;
    let center = marker.getLatLng();
    let latlng1 = latlng.clone();
    let latlng2 = latlng.clone();
    latlng1.lat = center.lat;
    latlng2.lng = center.lng;
    let r = latlng1.distanceTo(center);
    let ry = latlng2.distanceTo(center);
    //
    marker.setRadius(r);
    marker.setRadiusY(ry);
    marker.redraw();
  }

}



// WEBPACK FOOTER //
// ./src/plugins/tools/EllipseTool.js